import { outdent } from 'outdent';
import type { DevCenterComponent } from '../../../dev-center/components/dev-center-component.js';
import { getComponentPathWithHMR } from '../hmr/plugin.js';

export const getDashboardComponentDevTemplate = (
  appId: string,
  dashboardComponent: DevCenterComponent<
    'DashboardPage' | 'DashboardModal' | 'DashboardPlugin'
  >
) => {
  return outdent`
    import { withContextualWixClient } from "@wix/cli-app/internal/platform-sdk/dashboard";

    (function () {
      const mfKey = '__module_federation__containers';
      window[mfKey] = window[mfKey] || {};
      window[mfKey]['${appId}'] = window[mfKey]['${appId}'] || {
        get: async (cmpId) => {
          const importFn = window[mfKey]['${appId}'][cmpId];
          const Component = await importFn();
          return () => Component;
        },
        init: async () => {
          ${
            // `/@vite/client` is a special module that should be available in dev mode.
            // For example, via this module Vite will set globals that we put in `define` config.
            `await import('/@vite/client');`
          }
        },
      };

      window[mfKey]['${appId}']['${dashboardComponent.id}'] = async () => {
        const componentImport = await import('${getComponentPathWithHMR(
          dashboardComponent.relativePath
        )}');
        return { default: withContextualWixClient(componentImport.default) };
      };
    })();
  `;
};

export const getDashboardComponentBuildTemplate = (
  appId: string,
  dashboardComponent: DevCenterComponent<
    'DashboardPage' | 'DashboardModal' | 'DashboardPlugin'
  >
) => {
  return outdent`
    import { withContextualWixClient } from "@wix/cli-app/internal/platform-sdk/dashboard";

    (function () {
      const mfKey = '__module_federation__containers';
      window[mfKey] = window[mfKey] || {};
      window[mfKey]['${appId}'] = window[mfKey]['${appId}'] || {
        get: async (cmpId) => {
          const importFn = window[mfKey]['${appId}'][cmpId];
          const Component = await importFn();
          return () => Component;
        },
        init: async () => {},
      };

      window[mfKey]['${appId}']['${dashboardComponent.id}'] = async () => {
        const componentImport = await import('/${
          dashboardComponent.relativePath
        }');
        return { default: withContextualWixClient(componentImport.default) };
      };
    })();
  `;
};
